import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Spin, Typography } from 'antd'
import getUserStats from 'api/dashboard/getUserStats'
import style from './style.module.scss'

interface PropType {
	clientId?: string
}
const { Title } = Typography
const UserCreatedCard: React.FC<PropType> = ({ clientId }) => {
	const [active, setActive] = useState<number>(0)
	const [InActive, setInActive] = useState<number>(0)
	const [loading, setLoading] = useState<boolean>(true)

	const userData = async () => {
		setLoading(true)
		try {
			const response = await getUserStats({ client: clientId })
			setActive(response.find(ele => ele._id.active)?.count || 0)
			setInActive(response.find(ele => ele._id.active === false)?.count || 0)
			setLoading(false)
		} catch {
			setLoading(false)
		}
	}

	useEffect(() => {
		userData()
	}, [clientId])
	return (
		<Card title='User Stats' className={style.layout}>
			<Spin spinning={loading}>
				<Row justify='space-between'>
					<Col span={7}>
						<Card title='Total Users'>
							<Title level={2}>{active + InActive}</Title>
						</Card>
					</Col>
					<Col span={7}>
						<Card title='Active Users'>
							<Title level={2}>{active}</Title>
						</Card>
					</Col>
					<Col span={7}>
						<Card title='In-Active Users'>
							<Title level={2}>{InActive}</Title>
						</Card>
					</Col>
				</Row>
			</Spin>
		</Card>
	)
}
UserCreatedCard.defaultProps = {
	clientId: undefined,
}
export default UserCreatedCard
